import { IsOptional } from "class-validator";

export class CreateRaceDto {
  @IsOptional()
  readonly raceId: string;

  @IsOptional()
  readonly currency: string;

  readonly entryFee: number;
  readonly startDate: Date;

  @IsOptional()
  readonly seed: number;

  readonly arena: string;
}